import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const back = sessionStorage.getItem("auth_return");
    (async () => {
      let dest = back || "/dashboard";
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        if (!back && data?.role === "admin") dest = "/bacheca";
      } catch (e) {
        console.error("google auth failed", e);
      } finally {
        sessionStorage.removeItem("auth_return");
        navigate(dest, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="w-10 h-10 rounded-full border-2 border-ember border-t-transparent animate-spin" />
    </div>
  );
};

export default AuthCallback;
